/**
 * @generated SignedSource<<431da4f5190d6a23091f981abbb7bfbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TaskKind = "other" | "measurement" | "cleaning" | "%future added value";
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type UpdateTaskTemplateInput = {
  taskTemplateId: string;
  updateTaskTemplateData: UpdateTaskTemplateData;
  clientMutationId?: string | null;
};
export type UpdateTaskTemplateData = {
  name?: string | null;
  taskKind?: TaskKind | null;
  measurementTemplateId?: string | null;
};
export type updatePageUpdateTaskTemplateMutation$variables = {
  input: UpdateTaskTemplateInput;
};
export type updatePageUpdateTaskTemplateMutationVariables = updatePageUpdateTaskTemplateMutation$variables;
export type updatePageUpdateTaskTemplateMutation$data = {
  readonly updateTaskTemplate: {
    readonly taskTemplate: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
      readonly taskKind: TaskKind;
      readonly measurementTemplate: {
        readonly id: string;
      } | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type updatePageUpdateTaskTemplateMutationResponse = updatePageUpdateTaskTemplateMutation$data;
export type updatePageUpdateTaskTemplateMutation = {
  variables: updatePageUpdateTaskTemplateMutationVariables;
  response: updatePageUpdateTaskTemplateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTaskTemplatePayload",
    "kind": "LinkedField",
    "name": "updateTaskTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskTemplate",
        "kind": "LinkedField",
        "name": "taskTemplate",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskKind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeasurementTemplate",
            "kind": "LinkedField",
            "name": "measurementTemplate",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserFieldError",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePageUpdateTaskTemplateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePageUpdateTaskTemplateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "83906abaa2f6a64445251afac7124324",
    "id": null,
    "metadata": {},
    "name": "updatePageUpdateTaskTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation updatePageUpdateTaskTemplateMutation(\n  $input: UpdateTaskTemplateInput!\n) {\n  updateTaskTemplate(input: $input) {\n    taskTemplate {\n      id\n      createdAt\n      name\n      taskKind\n      measurementTemplate {\n        id\n      }\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b16fb81a10954c5404bf046577c73de7";

export default node;
